__turbopack_context__.v({
  "description": "LoyaltyBenefitsSection-module__YzUNUW__description",
  "heading": "LoyaltyBenefitsSection-module__YzUNUW__heading",
  "headingRow": "LoyaltyBenefitsSection-module__YzUNUW__headingRow",
  "learnMore": "LoyaltyBenefitsSection-module__YzUNUW__learnMore",
  "section": "LoyaltyBenefitsSection-module__YzUNUW__section",
});
